export default "__VITE_PUBLIC_ASSET__83224afb__"